// One Pi on the Operations → Pis quick-look grid (CJ 2026-10-06): an icon for
// what it runs, its status, and — for a KDS — labels printed today. Everything
// else is in the detail card that opens when the tile is picked.

export const DOT = { ok: '#2e7d32', warn: '#f9a825', down: '#c62828', new: '#9e9e9e' };
export const WORD = { ok: 'OK', warn: 'Check', down: 'Problem', new: 'New' };
const ROLE_ICON = { kds: ['🖨️', 'KDS + label printers'], menu: ['📺', 'Menu screens'] };

export function FleetTile({ d, selected, onSelect }) {
  const level = d.status.level;
  const roles = d.roles || [];
  const jobs = d.last_heartbeat?.kds?.reachable ? d.last_heartbeat.kds.print_jobs_today : null;
  const problem = d.status.problems[0]?.text;
  return (
    <button type="button" onClick={onSelect} aria-pressed={selected} data-fleet-tile={d.id}
      style={{ textAlign: 'left', background: '#fff', borderRadius: 10, padding: 12, cursor: 'pointer',
               fontFamily: 'inherit', color: 'inherit', display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0,
               border: '1px solid #e3e5e8', borderTop: `5px solid ${DOT[level]}`,
               boxShadow: selected ? '0 0 0 2px #1f2a44' : 'none' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 6 }}>
        <span style={{ fontSize: 26, lineHeight: 1 }}>
          {roles.map((r) => (
            <span key={r} role="img" aria-label={ROLE_ICON[r]?.[1] || r} title={ROLE_ICON[r]?.[1] || r}>{ROLE_ICON[r]?.[0] || '❔'}</span>
          ))}
        </span>
        <span style={{ fontSize: 12, fontWeight: 700, color: DOT[level], whiteSpace: 'nowrap' }}>● {WORD[level]}</span>
      </div>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 700, lineHeight: 1.25, overflowWrap: 'anywhere' }}>{d.name}</div>
        <div className="text-xs text-gray-500">{d.location_name || 'No store'}</div>
      </div>
      {roles.includes('kds') && (
        <div>
          <span style={{ fontSize: 24, fontWeight: 700, lineHeight: 1 }}>{jobs ? jobs.printed ?? 0 : '—'}</span>
          <span className="text-xs text-gray-500"> labels today</span>
          {jobs?.failed > 0 && <div style={{ fontSize: 12, fontWeight: 700, color: DOT.down }}>{jobs.failed} failed</div>}
        </div>
      )}
      {level !== 'ok' && problem && (
        <div style={{ fontSize: 12, color: level === 'down' ? DOT.down : '#8d6e00', overflow: 'hidden',
                      display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{problem}</div>
      )}
    </button>
  );
}
